import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import IcModalError from '../modal-error.svg';
import IcModalSuccess from '../modal-success.svg';
import { CustomHeroButton, ResponsiveModal, Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';

interface CodeVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSuccess: boolean;
  error?: string;
}

const CodeVerificationModal: React.FC<CodeVerificationModalProps> = ({
  isOpen,
  onClose,
  isSuccess,
  error,
}) => {
  const { t } = useTranslations();
  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose}>
      <ModalContent className="md:w-[25rem]">
        <ModalHeader className="flex items-center gap-2">
          {isSuccess ? (
            <>
              <img src={IcModalSuccess} alt="Success" />
              <h3 className="text-lg font-medium">{t('createAccount.modal.codeFound')}</h3>
            </>
          ) : (
            <>
              <img src={IcModalError} alt="Error" />
              <h3 className="text-lg font-medium">{t('createAccount.modal.codeNotFound')}</h3>
            </>
          )}
        </ModalHeader>
        <ModalBody className="pt-3 px-4 md:px-6 pb-6">
          <Typography variant="body2">
            {error
              ? error
              : isSuccess
                ? t('createAccount.modal.successMessage')
                : t('createAccount.modal.errorMessage')}
          </Typography>
        </ModalBody>
        <ModalFooter>
          <CustomHeroButton onPress={onClose} title={t('createAccount.buttons.continue')} />
        </ModalFooter>
      </ModalContent>
    </ResponsiveModal>
  );
};

export default CodeVerificationModal;
